import React from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';


export default function RcsSupplierInfoTableItem (props) {
  const { name, definition } = props;

  return (
    <div className='rcs-supplier-info-table--feature'>
      <span
        className='rcs-supplier-info-table--name'
        title={name}
      >
        {name}
      </span>
      <span
        className='rcs-supplier-info-table--definition'
        title={isString(definition) ? definition : null}
      >
        {definition}
      </span>
    </div>
  );
}

RcsSupplierInfoTableItem.propTypes = {
  name: PropTypes.string.isRequired,
  definition: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
};
